import React, { Component } from "react";
import Divider from '@material-ui/core/Divider';
import { findById } from './peopleBody.filters';
import {
  StyledHeader
  , StyledImageLoader
  , StyledDefaultPerson
  , StyledNameDiv
  , StyledTitle
  , StyledLabel
  , LABEL_NAMES
} from "./peopleBody.helper";

import {
  SecondaryButton
  , DefaultModuleHeader
  , ButtonSizeOptions
  , SupervisedUserCircle
} from '@loanbossinc/component-library';

export class PeopleBodyView extends Component {

  state = {
    brokerCompany: null
    , brokerContact: null
    , assetManager: null
    , teamMember: null
  }

  updateState = () => {
    this.setState({
      brokerCompany: {
        id: this.props.selectedIds.brokerCompanyId
        , list: this.props.brokers
        , label: LABEL_NAMES.BROKER_COMPANY
        , name: LABEL_NAMES.NONE_SELECTED
        , useImg: true
      }
      , brokerContact: {
        id: this.props.selectedIds.brokerContactId
        , list: this.props.companyContacts
        , label: LABEL_NAMES.BROKER_CONTACT
        , name: LABEL_NAMES.BROKER_COMPANY_REQUIRED
      }
      , assetManager: {
        id: this.props.selectedIds.assetManagerId
        , list: this.props.dealContacts
        , label: LABEL_NAMES.ASSET_MANAGER
        , name: LABEL_NAMES.NONE_SELECTED
      }
      , teamMember: {
        id: this.props.selectedIds.teamMemberId
        , list: this.props.dealContacts
        , label: LABEL_NAMES.TEAM_MEMBER
        , name: LABEL_NAMES.NONE_SELECTED
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props && !!this.props.selectedIds) {
      this.updateState();
    }
  }

  brokerCheck = (authInfo) => {
    const brokerData = {
      id: "8d6df618-4a9f-4e16-b010-0acbb92c5e20",
      name: "Broker"
    };

    const isBroker = authInfo?.companyTypes?.find((coTypes) => (coTypes.id === brokerData.id && coTypes.name === brokerData.name));
    return isBroker !== undefined;
  };

  renderRow = (item, isBroker = null) => {
    if (!item) return;
    const rowData = {
       ...item
      , ...findById(item.id, item.list)
    };
    return (
      <StyledHeader>
        <StyledNameDiv>
          <StyledLabel>{rowData.name}</StyledLabel>
          <StyledTitle>{isBroker ? "Relationship Manager" : rowData.label}</StyledTitle>
        </StyledNameDiv>
        {
          rowData.useImg ?
            <StyledImageLoader src={rowData.logoImage} defaultImage={process.env.PUBLIC_URL + "/images/default-lender-icon.svg"} />
            : <StyledDefaultPerson />
        }
      </StyledHeader>
    )
  }

  render() {
    const { onManageClick, isVisible, authentication } = this.props;
    if(!isVisible) return null;
    let button = <></>;
    if(authentication && !authentication.isGuest) 
      button = <SecondaryButton label={"Manage"} size={ButtonSizeOptions.smFluid} onClick={onManageClick} />

    return (
      <>
        <DefaultModuleHeader
          headerElement={[<SupervisedUserCircle />]}
          headerTitle="People"
          button={button}
        />

        {this.renderRow(this.state.brokerCompany)}
        <Divider />
        {this.renderRow(this.state.brokerContact, this.brokerCheck(authentication))}
        <Divider />
        {this.renderRow(this.state.assetManager)}
        <Divider />
        {this.renderRow(this.state.teamMember)}
      </>
    )
  }
}